<template>
  <div id="app">
    <router-view />
    <!--    <h1 @click="test">{{ $store.state.name }}</h1>-->
    <!--    <h1 @click="del">{{ $store.state.age }}</h1>-->
    <!--    <h1 @click="action">{{ this.$store.getters.fullInfo}}</h1>-->
  </div>
</template>

<script>
import Index from "./index/index";
export default {
  name: "App",
  components: {
    Index,
  },
  methods: {
    test() {
      this.$store.commit("edit", { age: 15, sex: "男" });
    },
    del() {
      this.$store.commit("del");
    },
    action() {
      let a = this.$store.dispatch("aEdit", { age: 11 });
      a.then(function (res) {
        console.log(res);
      });
    },
  },
};
</script>
<style lang="less">
@import "./style/layout/layout.less";
@import "./style/base/tool.less";

.lh {
  overflow: hidden;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  display: box;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.yh {
  overflow: hidden;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  display: box;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.el-popover {
  width: auto !important;
  height: 31px !important;
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  background: #3370ff !important;
  border-radius: 0px 10px 10px 10px !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-family: Microsoft YaHei !important;
  font-weight: 400 !important;
  text-align: center !important;
}
/* .el-popper[x-placement^=top] .popper__arrow::after {
        bottom: -0.2px;
        margin-left: -6px;
        border-top-color: #3370ff !important;
    } */

 .el-popover {
  background: #fff !important;

}
</style>



// WEBPACK FOOTER //
// src/App.vue